import React from 'react';
import { BoxProps, Box, Typography } from '@mui/material';

export interface Props extends BoxProps {
	title: string;
	description: string;
}
const HandlingTimesSection = (props: Props) => {
	const { title, description, children, ...boxProps } = props;
	return (
		<Box {...boxProps}>
			<Typography variant="h6" fontSize={18}>
				{title}
			</Typography>
			<Typography variant="body2" color="secondary" sx={{ maxWidth: 600 }}>
				{description}
			</Typography>
			{children}
		</Box>
	);
};

export default HandlingTimesSection;
